import useSWRImmutable from 'swr/immutable';
import { getWeedControlPlansFromAPI, getWeedsFromAPI } from './apiProviders';

export const useWeedControlPlansFromAPI = (
    {
        page,
        pageSize = 10,
    }: {
        page: number;
        pageSize?: number;
    },
    { enabled = true }: { enabled?: boolean } = { enabled: true }
) => {
    let key = null;
    if (enabled) key = { page, pageSize, key: 'getWeedControlPlansFromAPI' };

    return useSWRImmutable(key, ({ page, pageSize }) => getWeedControlPlansFromAPI({ page, pageSize }));
};

export const useWeedsFromAPI = (
    {
        countryCode,
        name,
        type,
        showInFinder,
    }: {
        countryCode: string;
        name?: string;
        type?: string;
        showInFinder?: boolean;
    },
    { enabled = true, keepPreviousData = false }: { enabled?: boolean; keepPreviousData?: boolean } = {
        enabled: true,
    }
) => {
    let key = null;
    if (enabled && countryCode) key = { countryCode, name, type, showInFinder, key: 'getWeedsFromAPI' };

    return useSWRImmutable(
        key,
        ({ countryCode, name, type, showInFinder }) => getWeedsFromAPI({ countryCode, name, type, showInFinder }),
        { keepPreviousData }
    );
};
